import React, {
	useState,
	useEffect,
	useCallback,
	useRef,
	Fragment,
} from "react";
import moment from "moment";
import { UserAuth } from "../context/AuthContext";

const SessionTimeout = () => {
	const [isOpen, setOpen] = useState(false);
	const { user, logout } = UserAuth();

	let warningInactiveInterval = useRef();
	let startTimerInterval = useRef();

	// warning timer
	const warningInactive = useCallback((timeString) => {
		clearTimeout(startTimerInterval.current);

		warningInactiveInterval.current = setInterval(() => {
			const maxTime = 2;
			const popTime = 1;

			const diff = moment.duration(moment().diff(moment(timeString)));
			const minPast = diff.minutes();

			if (minPast === popTime) {
				setOpen(true);
			}

			if (minPast === maxTime) {
				clearInterval(warningInactiveInterval.current);
				setOpen(false);
				sessionStorage.removeItem("lastTimeStamp");
				logout();
			}
		}, 150100);
	}, [logout]);

	// start inactive check
	const timeChecker = useCallback(() => {
		startTimerInterval.current = setTimeout(() => {
			let storedTimeStamp = sessionStorage.getItem("lastTimeStamp");
			warningInactive(storedTimeStamp);
		}, 150000);
	}, [warningInactive]);

	// reset interval timer
	const resetTimer = useCallback(() => {
		clearTimeout(startTimerInterval.current);
		clearInterval(warningInactiveInterval.current);

		if (user) {
			const timeStamp = moment();
			sessionStorage.setItem("lastTimeStamp", timeStamp);
		} else {
			clearInterval(warningInactiveInterval.current);
			sessionStorage.removeItem("lastTimeStamp");
		}
		timeChecker();
		setOpen(false);
	}, [timeChecker, user]);

	useEffect(() => {
		const events = ["click", "load", "scroll"];

		events.forEach((event) => {
			window.addEventListener(event, resetTimer);
		});

		timeChecker();

		return () => {
			events.forEach((event) => {
				window.removeEventListener(event, resetTimer);
			});
			clearTimeout(startTimerInterval.current);
			clearInterval(warningInactiveInterval.current);
		};
	}, [resetTimer, timeChecker]);

	if (!isOpen) {
		return null;
	}

	// change fragment to modal and handleclose func to close
	return <Fragment />;
};

export default SessionTimeout;
